import React from "react";
import YellowDivider from "../../dividers/YellowDivider";
import AboutCard from "./AboutCard";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

const OUR_JOURNEY_ITEMS = {
  en: [
    {
      title: "Long Story Short",
      body: "Did you know that the cornerstone of our project was an informal group on Telegram between a bunch of friends? And it wasn’t long before we noted that so many people around the world have a little to no access to learning material about the blockchain space, as well as a lack of social awareness towards this technology.",
    },
    {
      title: "Blockchain in Bits & Pieces",
      body: "ZeFi will provide you with access to a gamified learning experience on blockchain, with a daily dose of news and articles. We’re also working on a first-of-its-kind technical dictionary! Upcoming sections include a decentralized platform for freelancers, a market for a humanized NFT experience, and a forum for ZeCommunity.",
    },
    {
      title: "Hello… Hola… Merhaba!",
      body: "We've been a remote team since the very beginning of ZeFi. We’re bridging social distance by working as a team of 40+ folks, operating from more than 10 countries, and across  5 continents. In case you’re wondering, we’re allowed for time flexibility (finger crossed) but most importantly we’re an agile and dedicated global team.",
    },
    {
      title: "Talk of the Community",
      body: "We would like you to think of us as that sibling who is a young professional, tech savvy and eager to make a difference in their society. Yes, that’s because sometimes you may forget how much you can do, but we’re here to remind you that we’re a community-based foundation and you’re welcome to join our growing network.",
    },
  ],
  ar: [
    {
      title: "القصّة باختصار",
      body: 'لكلّ حكاية بداية، وحكايتنا بدأت من تطبيق "تلغرام" حيث اجتمعنا كأصدقاء ومعارف على حبّ المعرفة والنقاشات التي لا تنتهي. لم يمضِ وقت طويل قبل أن نلحظ أنّ الوعي المجتمعيّ مايزال ضعيفاً فيما يخصّ الاقتصاد.. رأس المال، والتكنولوجيا... وأنّ المحتوى العربيّ الخاصّ بفضاء البلوكتشين هشّ _ربما تجريديّ في الغالب_ وغير منفتح على النقاشات المتعلقة بأصل هذه العلوم وتطبيقاتها.',
    },
    {
      title: "لبلوكتشين من الألف إلى الياء",
      body: "نتطلّع لتوفير تجربة تعليم تفاعليّة، نقدّم من خلالها المعرفة الخاصّة بالبلوكتشين بطريقة ممتعة وتحاكي واقعنا في العالم العربيّ، بالإضافة إلى جرعة يوميّة من الأخبار والمقالات المتعلّقة بهذا العالم التقنيّ. كما أنّنا نؤسّس لقاموسٍ متخصّص هو الأوّل من نوعه في اللغة العربيّة! لدينا المزيد من المشاريع التي سنطلقها تباعاً خلال العام الحاليّ مثل منصّتنا اللامركزيّة للتوظيف، سوقنا الخاصّ بالرموز غير القابلة للاستبدال (NFTs)، ومنتدى حاضن لنقاشاتنا في مجتمع زي! ",
    },
    {
      title: "يا هلا بالجميع",
      body: "استطعنا منذ بداياتنا -كمبادرة مجتمعيّة وتقنيّة- سحق الهوّة التي يسببها التباعد الجغرافيّ بين أفرادها. أعطتنا المسافات دافعاً أكبر لتحقيق أهدافنا كمؤسّسة تضمّ أكثر من 40 شخصاً حول العالم، يملؤنا شغف المعرفة والتفاني في إيصالها بكلّ حبّ وفاعليّة!",
    },
    {
      title: "نتعلّم عبر التعليم",
      body: "لن نخفي عشقنا للتكنولوجيا، لا سيّما حين يتعلّق الأمر بالدفع نحو التغيير داخل مجتمعاتنا ولكنّنا في زيفاي نسعى دائماً أن نذكّر أنفسنا بالقدرة التي لدينا لإحداث فرقٍ حقيقيّ. ها نحن، مبادرة مجتمعيّة لا ترضى بالسكون، وتبحث عنك أينما كنت كي نتحرّك معاً",
    },
  ],
};

const OurJourney: React.FC = () => {
  const { ready, t, i18n } = useTranslation();

  const getJourneyItems = () => {
    if (i18n.language === "ar") {
      return OUR_JOURNEY_ITEMS.ar.map((item) => (
        <AboutCard
          key={`journey-item-${item.title.replaceAll(" ", "-").toLowerCase()}`}
          title={item.title}
          body={item.body}
        />
      ));
    }
    return OUR_JOURNEY_ITEMS.en.map((item) => (
      <AboutCard
        key={`journey-item-${item.title.replaceAll(" ", "-").toLowerCase()}`}
        title={item.title}
        body={item.body}
      />
    ));
  };

  return (
    <>
      <div className="mb-3 mb-lg-4">
        <h2>
          {ready ? t("about-zefi.our-journey.title") : <Skeleton width={350} />}
        </h2>
        <YellowDivider heading="h2" />
      </div>
      <div className="journey-outer">{getJourneyItems()}</div>
    </>
  );
};

export default OurJourney;
